import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { useFindCustomerDetailByIdMutation } from "../../../redux/services/customerService";
import { useResetPasswordMutation } from "../../../redux/services/userApi";
import { getUserData } from "../../../redux/slices/authSlice";
import MuiAlert from "../../MuiAlert/MuiAlert";

type Props = {};

const passwordSchema = Yup.object().shape({
  password: Yup.string()
    .required("Password is required")
    .min(6, "Password is too short"),
  confirmpassword: Yup.string()
    .required("Confirm Password is required")
    .oneOf([Yup.ref("password")], "Passwords must match"),
});

const ResetPassword = (props: Props) => {
  const userData = useSelector(getUserData);
  const [findById, findByIdResponse] = useFindCustomerDetailByIdMutation();
  const [resetPassword, resetPasswordResponse] = useResetPasswordMutation();
  const [statusCode, setStatusCode] = useState({ type: "", code: "" }) as any;
  const [isAlertVisible, setIsAlertVisible] = useState(false);
  const [formValues, setFormValues] = useState({
    password: "",
    confirmpassword: "",
  });
  const [data, setData] = useState({}) as any;

  const updateCustomerData = async (values: any, action: any) => {
    await resetPassword({
      payload: {
        merchantId: data?.merchantId,
        password: values.password,
        userId: data?.userId,
      },
      token: userData.jwtToken,
    });
    action.resetForm();
  };

  useEffect(() => {
    if (userData) {
      findById({ token: userData.jwtToken, id: userData.customerId });
    }
  }, []);
  useEffect(() => {
    if (resetPasswordResponse.isSuccess) {
      setStatusCode({
        type: "success",
        code: "UPDATEPASSWORD_SUCCESS",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
    if (resetPasswordResponse.isError) {
      setStatusCode({
        type: "error",
        code: "TECHNICAL_ERRORS",
      });
      setIsAlertVisible(true);
      setTimeout(() => {
        setIsAlertVisible(false);
      }, 5000);
    }
  }, [resetPasswordResponse.isSuccess]);

  useEffect(() => {
    if (findByIdResponse.isSuccess) {
      let custData = findByIdResponse.data;
      setData(custData);
    }
  }, [findByIdResponse.isSuccess || findByIdResponse.isError]);

  return (
    <div className=" rounded-[8px] border-2  lg:m-[50px] m-[20px] lg:mx-8 mx-2 p-[20px] lg:p-[32px]">
      <p className="text-[#434343] font-medium lg:text-[32px] text-[26px] mb-[24px] ml-6">
        Reset Password
      </p>
      <Formik
        enableReinitialize
        initialValues={formValues}
        onSubmit={updateCustomerData}
        validationSchema={passwordSchema}
      >
        {({
          handleBlur,
          handleChange,
          handleSubmit,
          values,
          touched,
          errors,
        }) => (
          <Box className="lg:mx-[110px] md:mx-[60px] mx-[20px]  mt-10 px-[10px]">
            {isAlertVisible && (
              <div>
                <MuiAlert
                  severity={statusCode?.type!}
                  messageType={statusCode?.code!}
                />
              </div>
            )}
            <Box
              className="mt-5"
              style={{
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Box className="mt-5" style={{ width: "100%" }}>
                <TextField
                  color="error"
                  variant="outlined"
                  fullWidth
                  type="password"
                  name="password"
                  id={"password"}
                  label={values.password ? "" : "New Password"}
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={Boolean(touched.password && errors.password)}
                  helperText={touched.password && errors.password}
                />
              </Box>
            </Box>
            <Box style={{ width: "100%" }} className="mt-5">
              <TextField
                color="error"
                fullWidth
                variant="outlined"
                type="password"
                name="confirmpassword"
                label={"Confirm Password"}
                value={values.confirmpassword}
                onChange={handleChange}
                onBlur={handleBlur}
                className={`form-control ${
                  errors.confirmpassword ? "is-invalid" : ""
                }`}
                error={Boolean(
                  touched.confirmpassword && errors.confirmpassword
                )}
                helperText={touched.confirmpassword && errors.confirmpassword}
              />
              <div className="border-b-[1px] mt-6 mb- text-slate-600 "></div>
            </Box>

            <Box
              className="justify-center md:justify-end mb-6 rounded-lg font-semibold"
              style={{
                width: "100%",
                display: "flex",
                marginTop: "20px",
                marginBottom: "40px",
              }}
            >
              <Button
                style={{
                  marginLeft: "10px",
                }}
                variant="contained"
                color="error"
                size="large"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Submit
              </Button>
            </Box>
          </Box>
        )}
      </Formik>
    </div>
  );
};

export default ResetPassword;
